module.exports = __webpack_public_path__ + "img/tham_logo.9f309914.png";